import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import FlashingItem from './FlashingItem';

export const FlashingList: React.FunctionComponent<{ messages: any[]}> = ({ messages }) => {
  const [messageState, setMessageState] = useState(messages)
  const messagesTop = useRef<HTMLDivElement>(null)
  const [firstItemFlashing, setFirstItemFlashing] = useState(false)
  useEffect(() => {
    if (messages.length === messageState.length + 1) {
      if (messages[0].flash_level && messages[0].flash_level > 0) {
        setFirstItemFlashing(true);
        scrollToTop()
      } else {
        setFirstItemFlashing(false);
      }
    }
    setMessageState(messages)
  }, [messages, messages.length, messageState.length])

  const scrollToTop = () => {
    if (messagesTop.current) {
      messagesTop.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (messageState.length === 0) { return <div /> }

    return (
      <FlashingListContainer>
        <div
          style={{ float: 'left', clear: 'both' }}
          ref={messagesTop}
        />
        <FlashingItem
          item={messages[0]}
          isFlashing={firstItemFlashing}
        />
        {messages.slice(1).filter(n => n.time).map((n, index) => <FlashingItem isFlashing={false} key={n.time + index} item={n} />)}
      </FlashingListContainer>
    );
  }

const FlashingListContainer = styled.div`
  padding: 10px 10px 0px 10px;
`;

export default FlashingList;
